import { listCouponsByEventIdService } from './listCouponsByEventIdService'
import * as _ from 'lodash'
import { api } from '../../api'
import { EventItem } from './listEventService'

export const listOneEventService = async (eventId: string) => {
  const { data } = await api.get(`/api/backoffice/events/${eventId}`)
  const coupons = await listCouponsByEventIdService(eventId)

  const tickets = data.eventItems.flatMap(
    (eventItem: { tickets: any[]; id: any }) =>
      eventItem.tickets.flatMap((ticket) => ({
        ...ticket,
        eventItems: eventItem
      }))
  )

  const eventItems = data.eventItems.flatMap((eventItem: EventItem) => ({
    ...eventItem,
    tickets: eventItem.tickets.flatMap((ticket) => ({
      ...ticket,
      eventItems: [{ ...eventItem, tickets: undefined }]
    }))
  }))

  return {
    ...data,
    coupons,
    eventItems: eventItems,
    tickets: _.uniqBy(tickets, 'id'),
    address: _.omitBy(data.address, _.isNil)
  }
}
